import { Address, AddressField } from '../service/AddressHelper/AddressHelper';
import { GeocodeResult } from '../service/YandexMapHelper/YandexMapHelper';
import { PointInfo, VcardData, VCardPhoneFields, VcardStatus } from '../typings/banners';
import { ValidationErrorData } from '../typings/common';
import { VisitingCardValue } from '../typings/VisitingCardEditor';

export const GET_VCARDS_FOR_BANNERS_EDIT = 'GET_VCARDS_FOR_BANNERS_EDIT';
export type GET_VCARDS_FOR_BANNERS_EDIT = typeof GET_VCARDS_FOR_BANNERS_EDIT;

export interface GetVCardsForBannersEdit {
    type: GET_VCARDS_FOR_BANNERS_EDIT;
    login: string;
    vCardIds: Array<string>;
}

export function getVCardsForBannersEdit(login: string, vCardIds: Array<string>): GetVCardsForBannersEdit {
    return {
        type: GET_VCARDS_FOR_BANNERS_EDIT,
        login,
        vCardIds
    };
}

export const OPEN_VCARD_EDITOR = 'OPEN_VCARD_EDITOR';
export type OPEN_VCARD_EDITOR = typeof OPEN_VCARD_EDITOR;

export interface OpenVCardEditor {
    type: OPEN_VCARD_EDITOR;
    editorId: string;
    vCardId: string;
    savedValue: VisitingCardValue;
}

export function openVCardEditor(editorId: string, vCardId: string, savedValue: VisitingCardValue): OpenVCardEditor {
    return {
        type: OPEN_VCARD_EDITOR,
        editorId,
        vCardId,
        savedValue
    };
}

export const CLOSE_VCARD_EDITOR = 'CLOSE_VCARD_EDITOR';
export type CLOSE_VCARD_EDITOR = typeof CLOSE_VCARD_EDITOR;

export interface CloseVCardEditor {
    type: CLOSE_VCARD_EDITOR;
    editorId: string;
}

export function closeVCardEditor(editorId: string): CloseVCardEditor {
    return {
        type: CLOSE_VCARD_EDITOR,
        editorId
    };
}

export const TOGGLE_VCARD_SHORT_VERSION_FLAG = 'TOGGLE_VCARD_SHORT_VERSION_FLAG';
export type TOGGLE_VCARD_SHORT_VERSION_FLAG = typeof TOGGLE_VCARD_SHORT_VERSION_FLAG;

export interface ToggleVCardShortVersionFlag {
    type: TOGGLE_VCARD_SHORT_VERSION_FLAG;
    editorId: string;
}

export function toggleVCardShortVersionFlag(editorId: string): ToggleVCardShortVersionFlag {
    return {
        type: TOGGLE_VCARD_SHORT_VERSION_FLAG,
        editorId
    };
}

export const TOGGLE_VCARD_NOT_SHOW_METRO_IN_SEARCH = 'TOGGLE_VCARD_NOT_SHOW_METRO_IN_SEARCH';
export type TOGGLE_VCARD_NOT_SHOW_METRO_IN_SEARCH = typeof TOGGLE_VCARD_NOT_SHOW_METRO_IN_SEARCH;

export interface ToggleVCardNotShowMetroInSearchFlag {
    type: TOGGLE_VCARD_NOT_SHOW_METRO_IN_SEARCH;
    editorId: string;
}

export function toggleVCardNotShowMetroInSearchFlag(editorId: string): ToggleVCardNotShowMetroInSearchFlag {
    return {
        type: TOGGLE_VCARD_NOT_SHOW_METRO_IN_SEARCH,
        editorId
    };
}

export const FETCH_VCARD_METRO_STATION = 'FETCH_VCARD_METRO_STATION';
export type FETCH_VCARD_METRO_STATION = typeof FETCH_VCARD_METRO_STATION;

export interface FetchVCardMetroStation {
    type: FETCH_VCARD_METRO_STATION;
    editorId: string;
    x: number;
    y: number;
}

export function fetchVCardMetroStation(editorId: string, x: number, y: number): FetchVCardMetroStation {
    return {
        type: FETCH_VCARD_METRO_STATION,
        editorId,
        x,
        y
    };
}

export const UPDATE_DRAFT_VCARD = 'UPDATE_DRAFT_VCARD';
export type UPDATE_DRAFT_VCARD = typeof UPDATE_DRAFT_VCARD;

export interface UpdateDraftVCard {
    type: UPDATE_DRAFT_VCARD;
    editorId: string;
    vCard: VcardData;
    vCardStatus?: VcardStatus;
}

export function updateDraftVCard(editorId: string, vCard: VcardData, vCardStatus?: VcardStatus): UpdateDraftVCard {
    return {
        type: UPDATE_DRAFT_VCARD,
        editorId,
        vCard,
        vCardStatus
    };
}

export const CHANGE_VCARD_STATUS = 'CHANGE_VCARD_STATUS';
export type CHANGE_VCARD_STATUS = typeof CHANGE_VCARD_STATUS;

export interface ChangeVCardStatus {
    type: CHANGE_VCARD_STATUS;
    vCardStatus: VcardStatus;
    editorId: string;
}

export function changeVCardStatus(editorId: string, vCardStatus: VcardStatus): ChangeVCardStatus {
    return {
        type: CHANGE_VCARD_STATUS,
        editorId,
        vCardStatus
    };
}

export const RESET_VCARD = 'RESET_VCARD';
export type RESET_VCARD = typeof RESET_VCARD;

export interface ResetVCard {
    type: RESET_VCARD;
    editorId: string;
    savedValue: VisitingCardValue;
}

export function resetVCard(editorId: string, savedValue: VisitingCardValue): ResetVCard {
    return {
        type: RESET_VCARD,
        editorId,
        savedValue
    };
}

export const SAVE_VCARDS = 'SAVE_VCARDS';
export type SAVE_VCARDS = typeof SAVE_VCARDS;

export interface SaveVCards {
    type: SAVE_VCARDS;
    editorId: string;
}

export function saveVCards(editorId: string): SaveVCards {
    return {
        type: SAVE_VCARDS,
        editorId
    };
}

export const SAVE_SUCCESS_FOR_EDITOR_VCARDS = 'SAVE_SUCCESS_FOR_EDITOR_VCARDS';
export type SAVE_SUCCESS_FOR_EDITOR_VCARDS = typeof SAVE_SUCCESS_FOR_EDITOR_VCARDS;

export interface SaveSuccessForEditorVCards {
    type: SAVE_SUCCESS_FOR_EDITOR_VCARDS;
    editorIds: string[];
    vCardIds: string[];
}

export function saveSuccessForEditorVCards(editorIds: string[], vCardIds: string[]): SaveSuccessForEditorVCards {
    return {
        type: SAVE_SUCCESS_FOR_EDITOR_VCARDS,
        editorIds,
        vCardIds
    };
}

export const UPDATE_VCARDS_ERRORS = 'UPDATE_VCARDS_ERRORS';
export type UPDATE_VCARDS_ERRORS = typeof UPDATE_VCARDS_ERRORS;

export interface UpdateVCardsErrors {
    type: UPDATE_VCARDS_ERRORS;
    editorIds: string[];
    updateEditorIds: string[];
    errors: Record<string, ValidationErrorData[]>;
}

export function updateVCardsErrors(
    editorIds: string[],
    updateEditorIds: string[],
    errors: Record<string, ValidationErrorData[]>
): UpdateVCardsErrors {
    return {
        type: UPDATE_VCARDS_ERRORS,
        editorIds,
        updateEditorIds,
        errors
    };
}

export const UPDATE_VISITING_CARD_ERRORS = 'UPDATE_VISITING_CARD_ERRORS';
export type UPDATE_VISITING_CARD_ERRORS = typeof UPDATE_VISITING_CARD_ERRORS;

export interface UpdateVisitingCardsErrors {
    type: UPDATE_VISITING_CARD_ERRORS;
    editorId: string;
    errors: ValidationErrorData[];
}

export function updateVisitingCardsErrors(editorId: string, errors: ValidationErrorData[]): UpdateVisitingCardsErrors {
    return {
        type: UPDATE_VISITING_CARD_ERRORS,
        editorId,
        errors
    };
}

export const REMOVE_VCARD_ERROR = 'REMOVE_VCARD_ERROR';
export type REMOVE_VCARD_ERROR = typeof REMOVE_VCARD_ERROR;

export interface RemoveVCardErrors {
    type: REMOVE_VCARD_ERROR;
    editorId: string;
    paths: Array<string>;
}

export function removeVCardErrors(editorId: string, paths: Array<string>): RemoveVCardErrors {
    return {
        type: REMOVE_VCARD_ERROR,
        editorId,
        paths
    };
}

export const CLEAR_VCARD = 'CLEAR_VCARD';
export type CLEAR_VCARD = typeof CLEAR_VCARD;

export interface ClearVCard {
    type: CLEAR_VCARD;
    editorIds: string[];
}

export function clearVCard(editorIds: string[]): ClearVCard {
    return {
        type: CLEAR_VCARD,
        editorIds
    };
}

export const UPDATE_VCARD_METRO_STATION_INFO = 'UPDATE_VCARD_METRO_STATION_INFO';
export type UPDATE_VCARD_METRO_STATION_INFO = typeof UPDATE_VCARD_METRO_STATION_INFO;

export interface UpdateVCardMetroStationInfo {
    type: UPDATE_VCARD_METRO_STATION_INFO;
    metroStationId: string;
    metroStationName: string;
    editorId: string;
}

export function updateVCardMetroStationInfo(
    metroStationId: string,
    metroStationName: string,
    editorId: string
): UpdateVCardMetroStationInfo {
    return {
        type: UPDATE_VCARD_METRO_STATION_INFO,
        metroStationId,
        metroStationName,
        editorId
    };
}

export const UPDATE_AND_OPEN_VCARD_FOR_EDIT = 'UPDATE_AND_OPEN_VCARD_FOR_EDIT';
export type UPDATE_AND_OPEN_VCARD_FOR_EDIT = typeof UPDATE_AND_OPEN_VCARD_FOR_EDIT;

export interface UpdateAndOpenVCardForEdit {
    type: UPDATE_AND_OPEN_VCARD_FOR_EDIT;
    vCards: Record<string, VcardData>;
}

export function updateAndOpenVCardForEdit(vCards: Record<string, VcardData>): UpdateAndOpenVCardForEdit {
    return {
        type: UPDATE_AND_OPEN_VCARD_FOR_EDIT,
        vCards
    };
}

export const UPDATE_VCARD_ADDRESS_INPUT_SUGGEST = 'UPDATE_VCARD_ADDRESS_INPUT_SUGGEST';
export type UPDATE_VCARD_ADDRESS_INPUT_SUGGEST = typeof UPDATE_VCARD_ADDRESS_INPUT_SUGGEST;

export interface UpdateVCardAddressInputSuggestAction {
    type: UPDATE_VCARD_ADDRESS_INPUT_SUGGEST;
    editorId: string;
    field: AddressField;
}

export function updateVCardAddressInputSuggest(
    editorId: string,
    field: AddressField
): UpdateVCardAddressInputSuggestAction {
    return {
        type: UPDATE_VCARD_ADDRESS_INPUT_SUGGEST,
        editorId,
        field
    };
}

export const UPDATE_VCARD_ADDRESS_INPUT = 'UPDATE_VCARD_ADDRESS_INPUT';
export type UPDATE_VCARD_ADDRESS_INPUT = typeof UPDATE_VCARD_ADDRESS_INPUT;

export interface UpdateVCardAddressInput {
    type: UPDATE_VCARD_ADDRESS_INPUT;
    address: Address;
    editorId: string;
    field: AddressField;
}

export function updateVCardAddressInput(
    address: Address,
    editorId: string,
    field: AddressField
): UpdateVCardAddressInput {
    return {
        type: UPDATE_VCARD_ADDRESS_INPUT,
        address,
        editorId,
        field
    };
}

export const UPDATE_VCARD_ADDRESS_MAP_POINT = 'UPDATE_VCARD_ADDRESS_MAP_POINT';
export type UPDATE_VCARD_ADDRESS_MAP_POINT = typeof UPDATE_VCARD_ADDRESS_MAP_POINT;

export interface UpdateVCardAddressMapPoint {
    type: UPDATE_VCARD_ADDRESS_MAP_POINT;
    pointOnMap: PointInfo | null;
    geoId: number;
    editorId: string;
    geoObject: GeocodeResult;
}

export function updateVCardAddressMapPoint(
    pointOnMap: PointInfo | null,
    editorId: string,
    geoId: number,
    geoObject: GeocodeResult
): UpdateVCardAddressMapPoint {
    return {
        type: UPDATE_VCARD_ADDRESS_MAP_POINT,
        pointOnMap,
        geoId,
        editorId,
        geoObject
    };
}

export const ON_CHANGE_VCARD_ADDRESS_MAP_POINT = 'ON_CHANGE_VCARD_ADDRESS_MAP_POINT';
export type ON_CHANGE_VCARD_ADDRESS_MAP_POINT = typeof ON_CHANGE_VCARD_ADDRESS_MAP_POINT;

export interface OnChangeVCardAddressMapPoint {
    type: ON_CHANGE_VCARD_ADDRESS_MAP_POINT;
    pointOnMap: PointInfo | null;
    editorId: string;
}

export function onChangeVCardAddressMapPoint(pointOnMap: PointInfo, editorId: string): OnChangeVCardAddressMapPoint {
    return {
        type: ON_CHANGE_VCARD_ADDRESS_MAP_POINT,
        pointOnMap,
        editorId
    };
}

export const UPDATE_VCARD_ADDRESS_SUGGEST = 'UPDATE_VCARD_ADDRESS_SUGGEST';
export type UPDATE_VCARD_ADDRESS_SUGGEST = typeof UPDATE_VCARD_ADDRESS_SUGGEST;

export interface UpdateVCardAddressSuggest {
    type: UPDATE_VCARD_ADDRESS_SUGGEST;
    editorId: string;
    suggest: string[];
    field: AddressField;
}

export function updateVCardAddressSuggest(
    suggest: string[],
    editorId: string,
    field: AddressField
): UpdateVCardAddressSuggest {
    return {
        type: UPDATE_VCARD_ADDRESS_SUGGEST,
        field,
        editorId,
        suggest
    };
}

export const ON_UPDATE_VCARD_ADDRESS_FORM_BY_FIELD = 'ON_UPDATE_VCARD_ADDRESS_FORM_BY_FIELD';
export type ON_UPDATE_VCARD_ADDRESS_FORM_BY_FIELD = typeof ON_UPDATE_VCARD_ADDRESS_FORM_BY_FIELD;

export interface OnUpdateVCardAddressFormByField {
    type: ON_UPDATE_VCARD_ADDRESS_FORM_BY_FIELD;
    editorId: string;
    field: AddressField;
}

export function onUpdateVCardAddressFormByField(
    editorId: string,
    field: AddressField
): OnUpdateVCardAddressFormByField {
    return {
        type: ON_UPDATE_VCARD_ADDRESS_FORM_BY_FIELD,
        editorId,
        field
    };
}

export const UPDATE_VCARD_GEO_OBJECT = 'UPDATE_VCARD_GEO_OBJECT';
export type UPDATE_VCARD_GEO_OBJECT = typeof UPDATE_VCARD_GEO_OBJECT;

export interface UpdateVCardGeoObject {
    type: UPDATE_VCARD_GEO_OBJECT;
    editorId: string;
    geoId: number;
    geoObject: GeocodeResult;
}

export function updateVCardGeoObject(editorId: string, geoId: number, geoObject: GeocodeResult): UpdateVCardGeoObject {
    return {
        type: UPDATE_VCARD_GEO_OBJECT,
        editorId,
        geoId,
        geoObject
    };
}

export const ON_SET_WARNING_TOOLTIP_VCARD_ADDRESS_FORM = 'ON_SET_WARNING_TOOLTIP_VCARD_ADDRESS_FORM';
export type ON_SET_WARNING_TOOLTIP_VCARD_ADDRESS_FORM = typeof ON_SET_WARNING_TOOLTIP_VCARD_ADDRESS_FORM;

export interface OnSetWarningTooltipVCardAddressForm {
    type: ON_SET_WARNING_TOOLTIP_VCARD_ADDRESS_FORM;
    editorId: string;
}

export function onSetWarningTooltipVCardAddressForm(editorId: string): OnSetWarningTooltipVCardAddressForm {
    return {
        type: ON_SET_WARNING_TOOLTIP_VCARD_ADDRESS_FORM,
        editorId
    };
}

export const SHOW_WARNING_TOOLTIP_VCARD_ADDRESS_FORM = 'SHOW_WARNING_TOOLTIP_VCARD_ADDRESS_FORM';
export type SHOW_WARNING_TOOLTIP_VCARD_ADDRESS_FORM = typeof SHOW_WARNING_TOOLTIP_VCARD_ADDRESS_FORM;

export interface ShowWarningTooltipVCardAddressForm {
    type: SHOW_WARNING_TOOLTIP_VCARD_ADDRESS_FORM;
    editorId: string;
    newGeoObject?: GeocodeResult;
    geoId: number;
    selfChooseGeoObject: GeocodeResult;
    pointOnMap: PointInfo | null;
}

export function showWarningTooltipVCardAddressForm(
    editorId: string,
    pointOnMap: PointInfo | null,
    geoId: number,
    selfChooseGeoObject: GeocodeResult,
    newGeoObject?: GeocodeResult
): ShowWarningTooltipVCardAddressForm {
    return {
        type: SHOW_WARNING_TOOLTIP_VCARD_ADDRESS_FORM,
        editorId,
        newGeoObject,
        geoId,
        selfChooseGeoObject,
        pointOnMap
    };
}

export const DECLINE_WARNING_TOOLTIP_VCARD_ADDRESS_FORM = 'DECLINE_WARNING_TOOLTIP_VCARD_ADDRESS_FORM';
export type DECLINE_WARNING_TOOLTIP_VCARD_ADDRESS_FORM = typeof DECLINE_WARNING_TOOLTIP_VCARD_ADDRESS_FORM;

export interface DeclineWarningTooltipVCardAddressForm {
    type: DECLINE_WARNING_TOOLTIP_VCARD_ADDRESS_FORM;
    editorId: string;
}

export function declineWarningTooltipVCardAddressForm(editorId: string): DeclineWarningTooltipVCardAddressForm {
    return {
        type: DECLINE_WARNING_TOOLTIP_VCARD_ADDRESS_FORM,
        editorId
    };
}

export const FETCH_PHONE_CODE_BY_ADDRESS_FOR_VCARD = 'FETCH_PHONE_CODE_BY_ADDRESS_FOR_VCARD';
export type FETCH_PHONE_CODE_BY_ADDRESS_FOR_VCARD = typeof FETCH_PHONE_CODE_BY_ADDRESS_FOR_VCARD;

export interface FetchPhoneCodeByAddressForVCard {
    type: FETCH_PHONE_CODE_BY_ADDRESS_FOR_VCARD;
    address: string;
    editorId: string;
    codeType: VCardPhoneFields;
}

export function fetchPhoneCodeByAddressForVCard(
    address: string,
    editorId: string,
    codeType: VCardPhoneFields
): FetchPhoneCodeByAddressForVCard {
    return {
        type: FETCH_PHONE_CODE_BY_ADDRESS_FOR_VCARD,
        editorId,
        address,
        codeType
    };
}

export const UPDATE_PHONE_CODE_BY_REGION_ID_FOR_VCARD = 'UPDATE_PHONE_CODE_BY_REGION_ID_FOR_VCARD';
export type UPDATE_PHONE_CODE_BY_REGION_ID_FOR_VCARD = typeof UPDATE_PHONE_CODE_BY_REGION_ID_FOR_VCARD;

export interface UpdatePhoneCodeByRegionIdForVCard {
    type: UPDATE_PHONE_CODE_BY_REGION_ID_FOR_VCARD;
    code: number;
    editorId: string;
    codeType: VCardPhoneFields;
}

export function updatePhoneCodeByRegionIdForVCard(
    code: number,
    editorId: string,
    codeType: VCardPhoneFields
): UpdatePhoneCodeByRegionIdForVCard {
    return {
        type: UPDATE_PHONE_CODE_BY_REGION_ID_FOR_VCARD,
        editorId,
        code,
        codeType
    };
}

export const UPDATE_SELF_CHOOSE_VCARD_MAP_POSITION = 'UPDATE_SELF_CHOOSE_VCARD_MAP_POSITION';
export type UPDATE_SELF_CHOOSE_VCARD_MAP_POSITION = typeof UPDATE_SELF_CHOOSE_VCARD_MAP_POSITION;

export interface UpdateSelfChooseVCardMapPosition {
    type: UPDATE_SELF_CHOOSE_VCARD_MAP_POSITION;
    editorId: string;
    selfChooseGeoObject: GeocodeResult;
}

export function updateSelfChooseVCardMapPosition(
    editorId: string,
    selfChooseGeoObject: GeocodeResult
): UpdateSelfChooseVCardMapPosition {
    return {
        type: UPDATE_SELF_CHOOSE_VCARD_MAP_POSITION,
        editorId,
        selfChooseGeoObject
    };
}

export type VisitingCardEditorAction =
    | UpdateSelfChooseVCardMapPosition
    | GetVCardsForBannersEdit
    | OpenVCardEditor
    | UpdatePhoneCodeByRegionIdForVCard
    | FetchPhoneCodeByAddressForVCard
    | OnSetWarningTooltipVCardAddressForm
    | OnUpdateVCardAddressFormByField
    | UpdateVCardAddressInputSuggestAction
    | UpdateVCardAddressMapPoint
    | OnChangeVCardAddressMapPoint
    | UpdateVCardAddressInput
    | CloseVCardEditor
    | ToggleVCardShortVersionFlag
    | ShowWarningTooltipVCardAddressForm
    | UpdateVCardAddressSuggest
    | DeclineWarningTooltipVCardAddressForm
    | ToggleVCardNotShowMetroInSearchFlag
    | UpdateDraftVCard
    | ResetVCard
    | SaveVCards
    | UpdateAndOpenVCardForEdit
    | UpdateVCardGeoObject
    | FetchVCardMetroStation
    | UpdateVCardMetroStationInfo
    | SaveSuccessForEditorVCards
    | UpdateVCardsErrors
    | RemoveVCardErrors
    | ClearVCard
    | ChangeVCardStatus
    | UpdateVisitingCardsErrors;
